import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const IDLE_TIMEOUT_MS = 60000; // 60 seconds

const EVENTS = ['touchstart', 'touchmove', 'mousedown', 'mousemove', 'keydown', 'scroll'];

/**
 * Watches for user inactivity and navigates to '/' after IDLE_TIMEOUT_MS.
 * Does nothing when already on the home screen.
 */
function useIdleRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const timer = useRef(null);

  useEffect(() => {
    if (location.pathname === '/') return;

    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => navigate('/'), IDLE_TIMEOUT_MS);
    };

    reset();
    EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }));

    return () => {
      clearTimeout(timer.current);
      EVENTS.forEach(e => window.removeEventListener(e, reset));
    };
  }, [location.pathname, navigate]);
}

export default useIdleRedirect;
